// Mock data for SIQ Adventures — frontend-only clone

export const NAV_LINKS = [
  { label: "The Story", href: "#film" },
  { label: "The Island", href: "#island" },
  { label: "Experiences", href: "#experiences" },
  { label: "DIY Guide", href: "/diy-guide" },
];

export const HERO = {
  eyebrow: "Siquijor Island · Philippines",
  titleTop: "Love the story,",
  titleBottom: "live the island.",
  subtitle:
    "SIQ Adventures brings to you Siquijor experiences led by local guides who grew up chasing these waterfalls, free diving these reefs and listening to the island's oldest stories.",
  video: "/hero-banner.mp4",
  bg: "https://images.unsplash.com/photo-1610805177214-885738d255f1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHx0cm9waWNhbCUyMHdhdGVyZmFsbHxlbnwwfHx8fDE3ODg5MTkyNzV8MA&ixlib=rb-4.1.0&q=85",
  stats: [
    { value: "11 yrs", label: "guiding" },
    { value: "Solo/Group", label: "travelers welcome" },
    { value: "100%", label: "local" },
  ],
};

export const FILM = {
  embedUrl: "https://www.youtube.com/embed/C8QZ3TGNdr8?rel=0",
  eyebrow: "The Story",
  title: "Love The Story, Live The Island film was made for the locals, by the locals:",
  subtitle:
    "Siquijor is more than a destination. It's a story waiting to be lived.\n\nFrom winding island roads and hidden waterfalls to beautiful beaches, local food, friendly faces and the moments you never planned for — SIQ Adventures is your local guide to things to do in Siquijor and experiencing the island beyond the usual tourist trail.\n\nWe believe the best way to discover Siquijor is to slow down, explore its beaches and waterfalls, connect with the people who call it home, and leave with stories of your own.\n\nWhether you're looking for the best things to do in Siquijor, hidden local gems, island adventures or simply a different way to experience the island, we're here to help you discover more.\n\nLove the story. Live the island. Kini ang Siquijor.",
};

export const GUIDE = {
  eyebrow: "Do It DIY",
  title: "The SIQ Adventures Digital DIY Guide",
  subtitle: "Siquijor Unlocked",
  cover: "/guide/cover.jpg",
  price: "A$12.99",
  checkoutUrl: "https://buy.stripe.com/7sYaEZ4ZOaoFaKEflZ0kE01",
  tagline:
    "There's so much more to Siquijor than a checklist — or what you see on Instagram.",
  madeForIntro:
    "Save yourself hours of research. The Siquijor DIY Guide is made for travellers who want to DIY! It's more than just the usual spots. Inside you'll find:",
  madeForBullets: [
    "2 ready-to-go Siquijor itineraries",
    "A master list of Siquijor's best tourist attractions",
    "Hidden waterfalls & local gems",
    "Where to eat, drink, grab coffee & experience local nightlife",
    "Which areas to stay and where to stay for every budget",
    "Where to rent bikes, cars & cameras",
    "Digital nomad tips",
    "Local stories & insights from Siquijor guides",
    "Practical tips on getting around, safety, money, etiquette & connectivity",
    "DIY vs guided tour advice + estimated costs",
  ],
  madeForClosing:
    "26 pages of local island insight. Instant access and unlimited updates.",
  madeForTags: [
    "The Coastal Loop",
    "Mountain & Mystic",
    "Local Food & Insider Tips",
    "DIY vs Guided Tour",
    "And Much More",
  ],
  inside: [
    { icon: "Map", label: "Itineraries" },
    { icon: "Palmtree", label: "Places & experiences" },
    { icon: "Bike", label: "Getting around" },
    { icon: "Wallet", label: "Real costs" },
    { icon: "Utensils", label: "Food" },
    { icon: "Home", label: "Accommodation" },
    { icon: "Compass", label: "Local knowledge" },
    { icon: "MapPin", label: "Practical tips" },
  ],
  screenshots: [
    { src: "/guide/page-1.jpg", heading: "Welcome to Siquijor" },
    { src: "/guide/page-2.jpg", heading: "Where to Stay in Siquijor" },
    { src: "/guide/page-3.jpg", heading: "DIY vs Guided Costs" },
    { src: "/guide/page-4.jpg", heading: "Where to Eat in Siquijor" },
    { src: "/guide/page-5.jpg", heading: "Digital Nomading" },
    { src: "/guide/page-6.jpg", heading: "Local Knowledge" },
  ],
  values: [
    {
      title: "Made for travellers who want to experience more",
      text: "Skip the cookie-cutter day-tours. This guide is for people who want to slow down and actually feel the island.",
    },
    {
      title: "Built from local knowledge",
      text: "Every page is written by locals who grew up here — the spots, the food and the timings only islanders know.",
    },
    {
      title: "Your purchase helps support Siquijor",
      text: "A portion of every guide sold goes straight back into community projects and donations across the island.",
    },
  ],
  finalTitle: "Ready to experience Siquijor?",
};

export const STORY = {
  eyebrow: "Our Story",
  title: "Love the story, live the island.",
  body:
    "We keep itineraries tailored so the places we love stay wild and we work with only local guides who are self employed. SIQ Adventures ensures you're in the right hands. Booking through SIQ Adventures ensures the cost of the tour goes back to local communities and their families.",
  features: [
    {
      icon: "MapPin",
      title: "Local First",
      text: "Guides born and raised in Siquijor, supporting other locals and Siquijodnon communities.",
    },
    {
      icon: "Leaf",
      title: "Sustainable Tourism",
      text: "Leave no trace, reef safe, respect and support local, regulate pricing",
    },
    {
      icon: "Heart",
      title: "DIY Guide Gives Back",
      text: "A portion of the Digital DIY Guide goes back into community projects and donations across the island.",
    },
  ],
  quote: "Love the Story, Live the Island Brand Film",
};

export const ISLAND = {
  eyebrow: "Isla del Fuego",
  title: "Siquijor",
  subtitle: "the island of fire",
  body1:
    "Known across the Philippines as the Island of Fire and folklore, Siquijor is a place of healers, century-old balete trees, hidden waterfalls the colour of jade, and some of the most beautiful beaches in the Philippines.\n\nBut Siquijor is also gentle: quiet coastal roads, white-sand coves, turquoise waters, sleepy villages, and a slower pace that seems to reset you within a day.\n\nThere are plenty of things to do in Siquijor, but we'll take you beyond the usual tourist trail — past the postcards and cookie-cutter itineraries, to hidden waterfalls, local beaches, roadside spots and the places that make island life feel truly alive.\n\nDiscover the sari-sari stores and karenderyas serving the best local food and snacks, meet the people who call Siquijor home, and learn about the healers who still practice the island's old traditions with warmth.\n\nBecause the best Siquijor travel experiences aren't always found on a map. Sometimes they're the places you stumble across, the people you meet, and the stories you take home.",
  body2: "",
  quote: "Some places stay with you forever. Come curious, leave connected.",
  images: [
    {
      src: "https://customer-assets-lqy194kg.emergentagent.net/job_siq-premium-escapes/artifacts/eyt9qzk0_Lugnason-Falls-Siquijor%20%281%29.webp",
      caption: "Lugnason Falls",
    },
    {
      src: "https://customer-assets-lqy194kg.emergentagent.net/job_siq-premium-escapes/artifacts/aw6lnyn8_Salagdoong.jpeg",
      caption: "Salagdoong Beach",
    },
    {
      src: "https://customer-assets-lqy194kg.emergentagent.net/job_siq-premium-escapes/artifacts/f8v95m6i_tubod.jpg",
      caption: "Tubod Beach",
    },
  ],
};

export const EXPERIENCES = [
  {
    id: "solo",
    title: "Solo/Couple Joiners Tour",
    image: "/tours/joiners.webp",
    price: "From A$15 pp",
    features: [
      "Min 5/Max 10 PAX Tour Groups",
      "DOT SIQ Guide",
      "Adventure Itinerary (bikes only)",
      "Enquire about select days",
    ],
    cta: "Tara Na!",
  },
  {
    id: "private",
    title: "Private Tours",
    image: "/tours/private.png",
    fit: "contain",
    price: "From A$45",
    features: [
      "2–48 PAX Private Tour",
      "DOT SIQ Guide & Drivers",
      "Tailored Itinerary Package",
      "8am pick up – 6pm drop off",
    ],
    cta: "Let's Go!",
  },
  {
    id: "freediving",
    title: "Isla Freediving",
    image: "/tours/freedive.jpg",
    price: "From A$70 pp",
    features: [
      "Certified freedive coach",
      "Safety guides",
      "Boat tour",
      "Mask & fins",
      "Video & footage",
      "Half day or full day · Solo or Group",
      "2–3 marine sanctuary spots",
    ],
    cta: "Reserve this trip",
  },
];

export const TEAM = [
  {
    name: "Luis",
    role: "Co-founder & Lead Guide",
    image: "/team/luis.jpg",
    bullets: [
      "11 years tour guiding",
      "Favorite location: Lugnason Falls",
      "Hopes Siquijor stays beautiful for generations to come",
    ],
  },
  {
    name: "Kim",
    role: "Tour Guide",
    image: "/team/kim.jpg",
    bullets: [
      "10 years tour guiding",
      "Skilled survival artist",
      "Favorite location: Lugnason Falls",
    ],
  },
  {
    name: "Loyd",
    role: "Luxury Tourism Guide",
    image: "/team/loyd.jpg",
    bullets: [
      "Over a decade in luxury Siquijor tourism",
      "11 years tour guiding",
      "Favorite spot: Lugnason Falls",
    ],
  },
  {
    name: "Rico",
    role: "Tour Guide",
    image: "/team/rico.jpg",
    bullets: [
      "1 year tour guiding",
      "Favorite location: Secret Beach",
      "Enjoys helping give back to the community",
    ],
  },
];

export const TESTIMONIAL = {
  quote:
    "Every island has a secret. Siquijor's is how quickly it makes you forget the rest of the world. Migo and the team made it feel like coming home.",
  name: "Hannah K.",
  location: "Berlin, Germany",
  avatar: "https://images.unsplash.com/photo-1483381616603-8dde934da56f?crop=entropy&cs=srgb&fm=jpg&w=200&q=80",
};

export const CONTACT = {
  email: "admin@siqadventures.com",
  phone: "+63 961 473 7456",
  phoneHref: "tel:+639614737456",
  instagram: "@siqadventures_",
  instagramHref: "https://www.instagram.com/siqadventures_/",
  facebook: "SIQ Adventures",
  facebookHref: "https://www.facebook.com/p/SIQ-Adventures-61573729635182/",
  location: "San Juan, Siquijor, Philippines",
  experienceOptions: [
    "Solo/Couple/Joiners",
    "Private Tours",
    "Isla Freediving",
    "Custom / not sure yet",
  ],
};
